var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvantages7({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_341_1727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.75 70.8333L54.1667 80.3333V91.6666H25C20.375 91.6666 16.6667 87.9583 16.6667 83.3333V16.6666C16.6667 14.4565 17.5447 12.3369 19.1075 10.7741C20.6703 9.21129 22.7899 8.33331 25 8.33331H29.1667V37.5L39.5834 31.25L50 37.5V8.33331H75C77.2102 8.33331 79.3298 9.21129 80.8926 10.7741C82.4554 12.3369 83.3334 14.4565 83.3334 16.6666V52.25L77.0834 48.8333L36.75 70.8333ZM100 70.8333L77.0834 58.3333L54.1667 70.8333L77.0834 83.3333L100 70.8333ZM62.5 79.5416V87.875L77.0834 95.8333L91.6667 87.875V79.5416L77.0834 87.5L62.5 79.5416Z",
    fill: "url(#paint0_linear_341_1727)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_341_1727",
    x1: 15.5441,
    y1: 99.0549,
    x2: 99.326,
    y2: 13.8326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0398851,
    stopColor: "#31D054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F64E4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_341_1727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantages7);
export default __webpack_public_path__ + "static/media/advantages_7.e3530bbb7ead7c064ea31b3a49cf04a0.svg";
export { ForwardRef as ReactComponent };